import template from "./pricing-table-preview.html";

const PricingTablePreviewComponent = {
  bindings: {
    pricingTable: "<",
    quoteLanguageResource: "<",
    editable: "<",
    onClick: "&",
    onChange: "&",
  },
  template: template,
  controller: class PricingTablePreviewController {
    /* @ngInject */
    constructor(QuoteLine, $filter) {
      this.QuoteLine = QuoteLine;
      this.$filter = $filter;
    }

    $onChanges() {
      if (this.pricingTable && this.pricingTable.lines.length === 0) {
        this.pricingTable.lines.push(
          new this.QuoteLine({
            description: this.$filter("trans")("pricingTablePreview.edit"),
            amount: 0,
            unit: this.$filter("trans")("pricingTablePreview.unit"),
            price: 0,
            discount: 0,
            from: null,
            costs: [],
          }),
        );
      }
    }
  },
};

export default PricingTablePreviewComponent;
